import * as React from "react"
import LayoutCoaching from "../components/layout-coaching"

const IndexPage = () => {
  return (
    <LayoutCoaching landingPage="/" />
  )
}

export default IndexPage
